module.exports = __webpack_public_path__ + "static/media/DSC_5794.2ed0b8ae.jpg";